import React from 'react';
import { Link } from "react-router";
import Nav from './../components/Nav';
import Posts from './../components/Posts';
import './../css/App.css';

const Home = () => {
    return (
        <>
            <Nav activeItem="home"/>
            <div className="hero">
              <p className="title">En Yeni Yazılar</p>
              <Link to="/"><img src="/favicon.png" className="asdf-icon"/></Link>
              <Link to="/"><p className="asdf">TALEFORCE</p></Link>
            </div>
            <div className="main">
              <div className="ad"></div>
              <div className="ad2"></div>
              <Posts/>
            </div>
            <style>{`
              .hero {
                background: url(/sss-banner.jpg);
                background-size: cover;
                padding: 100px 100px;
                margin-top: 50px;
                text-align: center;
              }

              .main {
                padding: 25px 0px 52px;
              }
  
              .title {
                color: #fff;
                text-align: center;
                margin: 0;
                padding: 0 0 5px;
                font-size: 34px;
                font-weight: bold;
              }
             
              .asdf {
                padding: 10px;
                font-size: 50px;
                display: none;
              }

              .asdf-icon {
                display: none;
              }

              .main {
                padding-bottom: 52px;
              }

              .main textarea::-webkit-scrollbar {
                width: 10px;
              }
              
              .main textarea::-webkit-scrollbar-track {
                background: #c15d28;
                border-radius: 10px;
              }
              
              .main textarea::-webkit-scrollbar-thumb {
                background: #2f2d33;
                border-radius: 10px;
              }
              
              .main textarea::-webkit-scrollbar-thumb:hover {
                opacity: .8;
              }

              .ad {
                width: 250px;
                height: 85%;
                background: red;
                position: fixed;
                left: 0;
                z-index: -1;
                display: none;
              }

              .ad2 {
                width: 250px;
                height: 85%;
                background: red;
                position: fixed;
                right: 0;
                z-index: -1;
                display: none;
              }

              @media (max-width: 623px) {
                .hero {
                  width: 100%;
                  position: fixed;
                  z-index: 1;
                  color: #fff;
                  background: #2f2d33;
                  height: 50px;
                  padding: 0;
                  margin: 0;
                  display: flex;
                }

                .main {
                  padding-top: 50px;
                }

                .title {
                  display: none;
                }

                .asdf {
                  margin: 0;
                  margin-left: 10px;
                  line-height: 50px;
                  padding: 0;
                  font-size: 20px;
                  display: block;
                }

                .asdf-icon {
                  display: block;
                  width: 32px;
                  height: 30px;
                  margin: 10px 0px 0px 10px;
                }
              }
            `}</style>
        </>
    );
};

export default Home;